import CareCostHourly from './CareCostHourly';

import Time from '../date/Time';

export default class ChildPlusTime {
    duration() {
        return this.timeRange.start.durationTo(this.timeRange.end);
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let plusTime = new ChildPlusTime();
        plusTime.id = data.id;
        plusTime.day = data.day;
        plusTime.formattedDay = data.formatted_day;
        plusTime.weekday = data.weekday;
        plusTime.timeRange = {
            start: Time.fromString(data.time_range.start),
            end: Time.fromString(data.time_range.end),
        };
        plusTime.careCostHourly = data.care_cost_hourly ? CareCostHourly.fromData(data.care_cost_hourly.data) : null;
        plusTime.hint = data.hint;

        return plusTime;
    }
}
